import { REQUEST_FORGOT_PASSWORD, FORGOT_PASSWORD_SUCCESS, FORGOT_PASSWORD_FAILURE, RESET_FORGOT_PASSWORD } from '../constants/action_types';
import { postForgotPassword } from '../api/api';
import { showEmailSent } from './signInModal';

const forgotPasswordSuccess = (data) => ({
    type: FORGOT_PASSWORD_SUCCESS,
    data
});

const forgotPasswordFailure = () => ({
    type: FORGOT_PASSWORD_FAILURE
});

const requestForgotPassword = () => ({
    type: REQUEST_FORGOT_PASSWORD
});

const submitForgotPassword = (data) => dispatch => {
    dispatch(requestForgotPassword());

    return postForgotPassword(data)
        .then(res => {
            if (!res.ok) {
                console.log('!res.ok');
                return dispatch(forgotPasswordFailure());
            }

            return (
                dispatch(forgotPasswordSuccess(data))
                    .then(dispatch(showEmailSent(data.email)))
            );
        })
        .catch(error => {
             return dispatch(forgotPasswordFailure());
         });
};

const resetForgotPassword = () => ({
    type: RESET_FORGOT_PASSWORD
});

export {
    submitForgotPassword,
    resetForgotPassword
};
